import gql from "graphql-tag";

export default gql`
  mutation SignUpFromRegistrationForm($registrationForm: UserRegistrationFormInput!, $utms: UTMParametersInput) {
    signUpFromRegistrationForm(registrationForm: $registrationForm, utms: $utms) {
      email
      isRecentlyCreatedUser
      accessToken
    }
  }
`;
